import { AnyAction } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  App,
  Gefahr,
  Leistung,
  Produkt,
  Produktlinie,
  TaasTarifrisikoschluessel,
  VwgVorbelegungdaten,
  waehlbareGefahren,
} from '@ps20-frontend/frontend-models';
import { produktReducer, updateZusatzoptionen } from '@ps20-frontend/reducers';
import { TaasTarifrisikoschluesselVWG, VorschadenArt, VorvertragBaustein } from '@ps20/bff-models';
import { ZUSATZOPTION_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { GefahrChecked } from '../action-types/gefahrChecked';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';
import { ZusatzoptionenNameVWGEnum } from '../models/zusatzoptionenVWG.model';

export const vwgProduktReducer = function (
  sectionState: Produkt = null,
  action: AnyAction,
  state: IAppState,
): Produkt {
  const newSectionstate = produktReducer(sectionState, action, App.VWG, state?.angebotsId);
  switch (action.type) {
    case VwgActions.GEFAHREN_CHECKED: {
      const actionPayload: Array<GefahrChecked> = action.payload;
      const newState: Produkt = cloneDeep(newSectionstate);

      for (const gefahrFromAction of actionPayload) {
        const produktlinie: Produktlinie = newState.produktlinien.find(
          elem => elem.produktName === gefahrFromAction.tarifItem.produktName,
        );

        const gefahr: Gefahr = produktlinie.gefahren.find(elem => elem.id === gefahrFromAction.id);

        gefahr.isSelected = gefahrFromAction.isSelected;
        if (waehlbareGefahren.includes(gefahr.id)) {
          changeLeistungenBeiGefahr(produktlinie.leistungen, gefahr);
        }

        produktlinie.leistungen.find(elem => elem.id === 'versicherteGefahren').eigenschaft =
          getVersicherteGefahrenCommaSeperated(produktlinie);
      }

      return newState;
    }
    case VwgActions.BRUTTOPREISE_CALCULATED:
    case VwgActions.PRODUKTLINIEN_CHANGED: {
      const produktlinien: Produktlinie[] = action.payload;
      return { ...newSectionstate, produktlinien };
    }
    case VwgActions.OELTANK_VORBELEGEN: {
      const updatedProduktlinien: Produktlinie[] = [];
      newSectionstate.produktlinien.forEach(
        (produktlinie, index) =>
          (updatedProduktlinien[index] = updateZusatzoptionen(
            produktlinie,
            TaasTarifrisikoschluesselVWG.OEL_TANK,
            true,
          )),
      );
      return { ...newSectionstate, produktlinien: updatedProduktlinien };
    }
    case VwgActions.PRODUKT_VORBELEGT: {
      const vwgVorbelegungdaten: VwgVorbelegungdaten = action.payload;
      const vorvertragBausteinList: VorvertragBaustein<TaasTarifrisikoschluessel>[] =
        vwgVorbelegungdaten?.vorvertragBausteinList;
      const newProduktLinien = newSectionstate?.produktlinien?.map(produktlinie => {
        if (produktlinie.zusatzoptionen) {
          produktlinie.zusatzoptionen.forEach(zusatzoption => {
            if (vorvertragBausteinList) {
              const vorbelegteZusatzOptionFound = vorvertragBausteinList.find(
                element => element?.taasTarifrisikoschluessel === zusatzoption?.name,
              );
              if (vorbelegteZusatzOptionFound) {
                zusatzoption.isSelected = true;
                zusatzoption.hinweis = vorbelegteZusatzOptionFound.hinweis || null;
              }
              return zusatzoption;
            }
          });
        }
        return produktlinie;
      });
      return { ...newSectionstate, produktlinien: newProduktLinien };
    }
    case VwgActions.DISABLE_ELEMENTAR_ZUSATZOPTION: {
      const newProduktLinien = newSectionstate.produktlinien.map(produktlinie => {
        produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
          if (zusatzoption.name === VorschadenArt.ELEMENTAR) {
            return { ...zusatzoption, disabled: true };
          }
          return zusatzoption;
        });
        return produktlinie;
      });
      return { ...newSectionstate, produktlinien: newProduktLinien };
    }
    case ZUSATZOPTION_CHECKED: {
      if (action.payload['name'] == ZusatzoptionenNameVWGEnum.ELEMENTAR) {
        const newProduktLinien = newSectionstate.produktlinien.map(produktlinie => {
          produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
            if (zusatzoption.name === VorschadenArt.ELEMENTAR) {
              return { ...zusatzoption, isSelected: true, disabled: false };
            }
            return zusatzoption;
          });
          return produktlinie;
        });
        return { ...newSectionstate, produktlinien: newProduktLinien };
      }
      return newSectionstate;
    }
    default:
      return newSectionstate;
  }
};

function getVersicherteGefahrenCommaSeperated(produktlinie: Produktlinie): string {
  let gefahrenString = '';
  const gefahren: Gefahr[] = produktlinie.gefahren.filter(elem => elem.isSelected);

  for (let _i = 0; _i < gefahren.length; _i++) {
    gefahrenString += gefahren[_i].label;
    if (_i < gefahren.length - 1) {
      gefahrenString += ', ';
    }
  }
  return gefahrenString;
}

function changeLeistungenBeiGefahr(leistungen: Leistung[], gefahr: Gefahr): void {
  leistungen
    .filter(lst => lst.gefahrId === gefahr.id)
    .forEach(lst => (lst.abgewaehlt = !gefahr.isSelected));
}
